import { memo, useMemo } from "react";
import ViewablePackageEntry from "../../ActiveQuoteReview/ViewablePackageEntry";
import EditablePackageEntry from "./EditablePackageEntry";
import {
  BasePackageEntryList,
  type BasePackageEntryListProps,
  type PackageEntryListProps,
} from "~/feature/cart/cart/components/CartPage/ProductTable/PackageEntryList";

export const ActiveQuotePackageEntryList = memo(({ packEntryIds, editMode, onRender }: PackageEntryListProps) => {
  const renderRow: BasePackageEntryListProps["renderRow"] = useMemo(() => {
    if (editMode) {
      return (id: number, index: number) => (
        <EditablePackageEntry key={id} className={"mb-2"} index={index} packEntryId={id} onRender={onRender} />
      );
    } else {
      return (id: number, index: number) => (
        <div key={id} className={"pb-2"}>
          <ViewablePackageEntry packEntryId={id} index={index} />
        </div>
      );
    }
  }, [editMode, onRender]);

  return <BasePackageEntryList packEntryIds={packEntryIds} renderRow={renderRow} />;
});

export default memo(ActiveQuotePackageEntryList);
